module.exports = __webpack_public_path__ + "static/melanydierks-resume2026-590a4f0275798bde80d8891d208c45d6.pdf";